// Liest eine Pflicht-Umgebungsvariable und bricht ab, wenn sie fehlt.
//
// Nur für Werte verwenden, ohne die die Anwendung nicht sinnvoll läuft
// (Auth0, API-Basis-URL). Konfiguration, deren Fehlen sich nur kosmetisch
// auswirkt, sollte stattdessen sichtbar degradieren statt die App zu stoppen.
export function requireEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`Umgebungsvariable ${key} ist nicht gesetzt. Bitte .env prüfen.`);
  }
  return value;
}
